// extracted by mini-css-extract-plugin
export default {"wrapper":"AddToCalendarButtons_wrapper__KPEtj"};